module.exports = __webpack_public_path__ + "9406e235aee15ca4bf8920edf0b13032.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/broadcom_2022_chart.png
// module id = 1644
// module chunks = 0